/**
 * Class for hero image.
 *
 * @class      Hero (name)
 */
export class Hero
{
	/**
	 * Adds the necessary event listeners.
	 */
	static addListeners()
	{
		// Wait for DOMContentLoaded
	    $( document ).ready(
			function()
			{
				// Initiate flexslider
				$( '.hero-slider .flexslider' ).flexslider(
					{
						animation:    'fade',
						controlNav:   true,
						directionNav: false,
					}
				);
		    }
		);
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/modules/hero/hero.js